import { OtpVerificationForm } from "@/features/auth/components/otp-verification-form";

export default function OtpVerificationPage() {
  return <OtpVerificationForm />;
}
